import React from "react";
import InfoBox from '../components/info.js'
import Habitation from './../../images/habitation-qc-2.png'
import Panoramic from "../components/panoramic.js";

export default () => (
    <Panoramic>
        <div className='metadata--wrapper'>
            <img src={Habitation} alt="Habitation de Québec" />
            <InfoBox>L&#39;Habitation à hauteur d&#39;homme. Illustration de Georges Gauthier Larouche, &quot;L&#39;habitation de Québec 1608-1615&quot;, Éditions Calligraphiques, 1982.</InfoBox>
        </div>
    </Panoramic>
);



// WEBPACK FOOTER //
// ./src/components/image-footer-axe1.js